// Events are scheduled in Kenya (EAT, UTC+3, no daylight saving).
// Date-only values ("2026-10-15") stay current until 23:59:59 EAT on that day.
export function isEventPast(date: string, now: Date = new Date()): boolean {
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return new Date(`${date}T23:59:59+03:00`).getTime() < now.getTime();
  }
  const parsed = new Date(date);
  return !Number.isNaN(parsed.getTime()) && parsed.getTime() < now.getTime();
}

// Parses a date-only value as a calendar day so it never shifts with the viewer's timezone
export function parseEventDate(date: string): Date {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return new Date(date);
}

/** Normalizes Kenyan mobile numbers to 254XXXXXXXXX (matches the API). */
export function normalizeKenyanPhone(value: string): string {
  const digits = value.trim().replace(/[\s\-()]/g, '').replace(/^\+/, '');
  if (/^0[17]\d{8}$/.test(digits)) return `254${digits.slice(1)}`;
  if (/^[17]\d{8}$/.test(digits)) return `254${digits}`;
  return digits;
}

export const KENYAN_PHONE_PATTERN = /^254[17]\d{8}$/;

/** Formats 254712345678 as +254 712 345 678 for display. */
export function formatKenyanPhone(value: string): string {
  if (!KENYAN_PHONE_PATTERN.test(value)) return value;
  return `+254 ${value.slice(3, 6)} ${value.slice(6, 9)} ${value.slice(9)}`;
}
